import { BarType } from 'types'

import img_bar from './bar.png'

export const bar: BarType = {
  id: 'bar',
  src: img_bar,
  style: {
    top: '',
    bottom: 0,
    display: 'none',
    backgroundImage: `url("${img_bar}")`,
  },
}
